import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

export default function Loading({ size, middle }) {
  return (
    <Box
      sx={{
        display: "flex",
        marginTop: middle ? "20%" : null,
        justifyContent: "center",
        justifySelf: "center",
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
}
